export default "__VITE_ASSET__DQEJ8_oj__"